const DEFAULT_HEIGHT = 90;

const ScrollablePage = ({background, menuHeight, children}) => <div style={{width: '100vw', height: `calc(100vh - ${menuHeight || DEFAULT_HEIGHT}px)`, overflow:'auto', marginTop: menuHeight || DEFAULT_HEIGHT}}>
  <div style={background}>
  {children}
  </div>
</div>;

export default ScrollablePage;